import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recent-exempt-transactions',
  templateUrl: './recent-exempt-transactions.component.html',
  styleUrls: ['./recent-exempt-transactions.component.scss']
})
export class RecentExemptTransactionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
